/* eslint-disable max-len */

import Cove from '@ctrack/cove';

/*
  Define all API endpoints here. A 'path' property is required and may contain path parameter arguments prefixed
  by a colon. An optional 'query' object can also be specified for any static query string values.
 */
Cove.setAPIs({
  'api.case': {
    path: '/cases/:caseID'
  },
  'api.cases.table': {
    path: '/cases/:caseID/:searchType'
  },
  'api.dynamicView.search': {
    path: '/dynamicview/search',
    query: {
      fields: '*,fieldDataTypeCode(viewFieldDataTypeValue)'
    }
  },
  'api.hearings': {
    path: '/hearings'
  },
  'api.publicAccessDocuments': {
    path: '/publicaccessdocuments'
  },
  'api.publicAccessDocuments.download': {
    path: '/publicaccessdocuments/:documentID/download'
  },
  'api.search': {
    path: '/:searchType/search'
  },
  'api.searches.types.fields': {
    path: '/searches/types/:searchTypeID/fields',
    query: {
      fields: 'searchFieldID,searchFieldName,advancedSearch,advancedSearchOrderBy,advancedSearchLabel,indexFieldID,indexFieldName,advancedSearchType(systemCodeValueID),fieldMappingType(searchFieldMappingTypeID)'
    }
  },
  'api.staticLinks': {
    path: '/staticlinks',
    query: {
      fields: 'linkName,linkURL,orderBy,staticLinkID'
    }
  },
  'api.userPermissions': {
    path: '/userpermissions'
  }
});
